export const loadFormstackForm = async (formId)=>{
    let headers = new Headers();
    headers.append('X-XSRF-TOKEN', document.getElementsByName("__RequestVerificationToken")[0].value);
    const res = await fetch(`/api/v1/formstack/form/${formId}`, {
        method: 'GET',
        credentials: 'include',
        headers: headers
    });
    if (400 <= res.status && res.status < 500) return {
        kind: 'unauthorized',
        status: res.status
    };
    if (res.status >= 500) return {
        kind: 'failed',
        status: res.status
    };
    const json = await res.json();
    return {
        kind: 'result',
        status: 200,
        value: json
    };
};
export const getWordCloudTags = async (formId, fieldId, amount)=>{
    let headers = new Headers();
    headers.append('X-XSRF-TOKEN', document.getElementsByName("__RequestVerificationToken")[0].value);
    const res = await fetch(`/api/v1/Formstack/form/${formId}/${fieldId}/get-word-cloud-tags/${amount}`, {
        method: 'GET',
        credentials: 'include',
        headers: headers
    });
    if (400 <= res.status && res.status < 500) return {
        kind: 'unauthorized',
        status: res.status
    };
    if (res.status >= 500) return {
        kind: 'failed',
        status: res.status
    };
    return {
        kind: 'result',
        status: 200,
        value: await res.json()
    };
};
